import type {
  AudienceInsightsQuery,
  AudienceInsightsResponse,
} from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function getAudienceInsights(
  query: AudienceInsightsQuery,
): Promise<AudienceInsightsResponse> {
  return apiClient
    .url("/social-publishing/insights/audience")
    .query(
      Object.fromEntries(
        Object.entries(query).filter(([, value]) => value !== undefined),
      ),
    )
    .get()
    .json();
}

export function useAudienceInsights(
  query: AudienceInsightsQuery,
): UseQueryResult<AudienceInsightsResponse, Error> {
  return useQuery({
    placeholderData: keepPreviousData,
    queryFn: () => getAudienceInsights(query),
    queryKey: socialPublishingKeys.audienceInsights(query),
  });
}
